export const mapRange = (v, xmin, xmax, fxmin, fxmax) => {
  const xDelta = xmax - xmin;
  const fxDelta = fxmax - fxmin;
  const x = (v - xmin) / xDelta;
  return fxmin + x * fxDelta;
};
